import type { Components, Theme } from '@mui/material/styles';

/**
 * Table cells (docs/ui-design.md): 13px body, 12px sentence-case
 * header with no tracking, numbers right-aligned in tabular figures.
 */
export const MuiTableCell: Components<Theme>['MuiTableCell'] = {
	styleOverrides: {
		root: {
			padding: 'var(--s2) var(--s3)',
			borderBottom: '1px solid var(--line)',
			verticalAlign: 'top',
			color: 'var(--ink)',
			fontFamily: 'var(--font-sans)',
			fontSize: 'var(--fs-body)',
			lineHeight: 1.4,
		},
		/* size="small" body rows land at ~36px (13px x 1.4 + 2 x 9px). */
		sizeSmall: {
			padding: '9px var(--s3)',
		},
		head: {
			textAlign: 'left',
			background: 'var(--surface-sunken)',
			color: 'var(--ink-2)',
			fontFamily: 'var(--font-sans)',
			fontSize: 'var(--fs-small)',
			textTransform: 'none',
			letterSpacing: 0,
			fontWeight: 600,
			lineHeight: 1.3,
			verticalAlign: 'bottom',
			borderBottom: '1px solid var(--line-strong)',
			'&.MuiTableCell-stickyHeader': {
				background: 'var(--surface-sunken)', // solid, so rows never show through
			},
		},
		footer: {
			background: 'var(--surface-sunken)',
			color: 'var(--ink)',
			fontWeight: 600,
			fontSize: 'var(--fs-body)',
			position: 'sticky',
			bottom: 0,
			borderTop: '1px solid var(--line-strong)',
		},
		alignRight: {
			textAlign: 'right',
			whiteSpace: 'nowrap',
			fontVariantNumeric: 'tabular-nums',
		},
		paddingCheckbox: { width: 40 },
	},
};
